/**
 * HomePage (route: "/" and "/home")
 * The public landing page. Composes only the sections that are live today:
 * Hero, About (with prayer times), Friday Prayer, Sadaqah Jariyah and Support.
 */
import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar';
import Hero from '../../components/hero';
import About from '../../components/about';
import FridayPrayer from '../../components/FridayPrayer';
import SadaqahJariyah from '../../components/SadaqahJariyah';
import Support from '../../components/Support';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
// TODO: Replace placeholder illustration with real Cole Harbour Masjid photos once available
import abimg from '../../images/placeholder-illustration.svg';
import hero1 from '../../images/placeholder-illustration.svg';

const HomePage = () => {
  return (
    <Fragment>
      <Navbar />
      <Hero HeroStyleClass={'hero-style-2'} heroImg={hero1} />
      <About aboutImg={abimg} />
      {/* TODO: Re-enable <Pilars /> here when the Five Pillars section is needed again. */}
      <FridayPrayer />
      <SadaqahJariyah />
      <Support />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default HomePage;
